import React, { useEffect } from 'react';
import { useState } from 'react';
import { Form, Button, Spinner, Col, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion } from "react-bootstrap";
import { FaAngleDoubleDown } from 'react-icons/fa';
import { DivisionWiseSalesRangeVW, currentMonthWorkingDays } from '../Redux/MapAction';
import LoadingSpinner from '../../modules/Billing/Components/LoadingSpinner';
import { numberFormat } from '../../Global/numberFormat';
import DownloadDropdown from "../../modules/master/PrintDwopdown/ExcelDawnload";


const DivisionWiseSalesRange = () => {

    const dispatch = useDispatch();
    const { register, setValue } = useForm();
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const handleAccordionToggle = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const regionDataFilter = [{}, {}];
    const currentDate = new Date();
    const initialMonth = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
    const [selectedMonth, setSelectedMonth] = useState(initialMonth);

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };


    const [startDate, setStartDate] = useState(initialMonth);
    const [toDate, setToDate] = useState(initialMonth);

    const handleChangeStartDate = (event) => {
       // alert(event.target.value)
        setStartDate(event.target.value);
        if(toDate < event.target.value)
        {
           setStartDate(toDate);
        }
        
    };

     const handleChangeTodate = (event) => {
        setToDate(event.target.value);

        if(startDate > event.target.value)
        {
           setToDate(startDate);
        }
    };
    

    // const handleChangeStartDate = ({ currentTarget: input }) => {
    //     console.log(input);
    //     setStartDate(input.value);
    // };

    // const handleChangeTodate = ({ currentTarget: input }) => {
    //     setToDate(input.value);
    // };

    console.log('selectedMonth', selectedMonth)
    const handleSummeryReport = async () => {
        dispatch(DivisionWiseSalesRangeVW(startDate, toDate))

    }

    

    useEffect(() => {
        initialData();
    }, [dispatch])

    const initialData = async () => {
        await dispatch(DivisionWiseSalesRangeVW(startDate, toDate))
        await dispatch(currentMonthWorkingDays())

    }
    const divisionSalesRangeDataViews = useSelector(state => state?.mapData?.divisionSalesRangeDataView?.allData);
    const workingDays = useSelector(state => state?.mapData?.currentMonhWorking?.allData);


    console.log('workingDays', workingDays?.totWorkingDay)

    const divisionSalesRangeDataViewIsLoading = useSelector(state => state?.mapData?.divisionSalesRangeDataViewIsLoading);
    const monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ];
    const monthNumber = divisionSalesRangeDataViews && divisionSalesRangeDataViews.length > 0 ? divisionSalesRangeDataViews[0]?.month : null;
    const monthName = monthNames[monthNumber - 1]; // Adjusting index since array is zero-based

    


    return (
        <div className='container ims-division-wise-report'>



            <div className=' container-fluid top_card3-map rounded mb-5'>
                <Accordion activeKey={isAccordionOpen ? "1" : "0"}>

                    <Accordion.Toggle as={Button} variant="link" eventKey="1" className="arrayButton" onClick={handleAccordionToggle}>
                        <div>
                            <div className="dailysales text-center dailysalesmargin dailysalesfont row  ">
                                <span className="sales-title-map" style={{ width: '400px', margin: 'auto' }} >Division wise Sales Range
                                    <div>
                                        <FaAngleDoubleDown className="float-right toparrow blink-text dropdownArrow" />
                                        <span className="clickHere float-right">
                                            {isAccordionOpen ? "Click to Close" : "Click to Expand"}
                                        </span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1" onEnter={() => setIsAccordionOpen(true)} onExit={() => setIsAccordionOpen(false)}>
                        <div>
                            <div className="row d-flex justify-content-center bg-blue ">



                                <div className="col-md-1.5 d-flex py-2 align-items-center justify-content-md-start justify-content-center">
                                    
                                        <Form.Group as={Col} controlId="formGridState">
                                            <label className="form-label text-light mb-0 text-right mr-3">From Month</label>
                                            <input
                                            type="month"
                                            placeholder="Enter From Month"                                                   
                                            value={startDate}
                                            className="form-control cusheight"
                                            onChange={handleChangeStartDate}
                                            />
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} controlId="formGridState">
                                            
                                        <label className="form-label text-light mb-0 text-right mr-3">To Month </label>
                                            <input
                                            type="month"
                                            placeholder="Enter To Month"                                                   
                                            value={toDate}
                                            className="form-control cusheight "
                                            onChange={handleChangeTodate}
                                            />
                                        </Form.Group>
                                              
                                    
                                    

                                    <div className="col-md-1.5 d-flex justify-content-center mt-5 ml-5">
                                   
                                        {toDate !== null ? (
                                            <button className="btn btn-primary btn-sm " onClick={() => handleSummeryReport()}>Filter</button>
                                            ) : null}
                                            
                                        </div>
                                </div>


                                
                            </div>

                        </div>

                    </Accordion.Collapse>
                </Accordion>
            </div>
           
            {
                divisionSalesRangeDataViewIsLoading &&
                <LoadingSpinner />

            }

            {!divisionSalesRangeDataViewIsLoading && <>
                <p className='export-for-excel'>
                    <DownloadDropdown excelname='Division wise ims Report' />
                </p>
                {divisionSalesRangeDataViews?.length <= 0 ? <p className='noAvailableata'>No Available data here</p> :

                    <div className="table-container">

                        <table id="table-to-xls" className="territory-table">
                            <thead className="bg-gray-100 text-xs uppercase text-gray-700">
                                <tr>
                                <th className="px-4 py-2 border">Division</th>
                                <th className="px-4 py-2 border">Zone</th>
                                <th className="px-4 py-2 border">Above 28K</th>
                                <th className="px-4 py-2 border">25K-28K</th>
                                <th className="px-4 py-2 border">20K-25K</th>
                                <th className="px-4 py-2 border">15K-20K</th>
                                <th className="px-4 py-2 border">Below 15K</th>
                                <th className="px-4 py-2 border">Total</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {divisionSalesRangeDataViews?.map((row, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border">{row.divisioN_NAME}</td>
                                    <td className="px-4 py-2 border">{row.zonE_NAME}</td>
                                    <td className="px-4 py-2 border">{row.abovE_28K}</td>
                                    <td className="px-4 py-2 border">{row.k_25_28}</td>
                                    <td className="px-4 py-2 border">{row.k_20_25}</td>
                                    <td className="px-4 py-2 border">{row.k_15_20}</td>
                                    <td className="px-4 py-2 border">{row.beloW_15K}</td>
                                    <td className="px-4 py-2 border font-bold">{row.totaL_COUNT}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        {/* <table id="table-to-xls" className="territory-table">
                            <thead className='header-working'>
                                <th>  </th>
                                <th> Working days:  {workingDays?.totWorkingDay}</th>
                                <th></th>
                              
                                <th></th>
                                <th> Working days Pass: {workingDays?.passWorkingDay}  </th>
                                <th>  </th>
                                <th></th>
                                <th>  Need IMS: {workingDays?.imsTarget.toFixed(2)}% </th>
                               

                            </thead>
                          
                           
                            <thead className="bg-gray-200 text-gray-800 font-bold text-center">
                                <tr>
                                    <th className="px-2 py-2">SL</th>
                                    <th className="px-4 py-2 text-left">Division</th>                                    
                                    <th className="px-4 py-2">Above 28K</th>
                                    <th className="px-4 py-2">25K - 28K</th>
                                    <th className="px-4 py-2">20K - 25K</th>
                                    <th className="px-4 py-2">15K - 20K</th>
                                    <th className="px-4 py-2">Below 15K</th>
                                    <th className="px-4 py-2">Total</th>
                                </tr>
                            </thead>
                            <tbody className="territory-tr ">
                              
                                
                                {groupedData.map((row, idx) => {
                                    if (row.isSubtotal) {                                    
                                    return (
                                        <tr key={`zone-total-${idx}`} className="bg-green-100 font-semibold">
                                        <td></td> 
                                        <td className="px-4 py-1 text-left text-green-800">
                                            Zone: {row.zonE_NAME}
                                        </td>
                                        <td className="text-center-style">{row.abovE_28K}</td>
                                        <td className="text-center-style">{row.k_25_28}</td>
                                        <td className="text-center-style">{row.k_20_25}</td>
                                        <td className="text-center-style">{row.k_15_20}</td>
                                        <td className="text-center-style">{row.beloW_15K}</td>
                                        <td className="text-center-style">{row.totaL_COUNT}</td>
                                        </tr>
                                    );
                                    } else {                                    
                                    const slNo = groupedData
                                        .filter((r, i) => !r.isSubtotal && i <= idx)
                                        .length;

                                    return (
                                        <tr key={`div-${idx}`} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                                        <td className="text-center-style">{slNo}</td>
                                        <td className="px-4 py-1">{row.divisioN_NAME}</td>                                        
                                        <td className="text-center-style">{row.abovE_28K}</td>
                                        <td className="text-center-style">{row.k_25_28}</td>
                                        <td className="text-center-style">{row.k_20_25}</td>
                                        <td className="text-center-style">{row.k_15_20}</td>
                                        <td className="text-center-style">{row.beloW_15K}</td>
                                        <td className="text-center-style">{row.totaL_COUNT}</td>
                                        </tr>
                                    );
                                    }
                                })}
                                </tbody>

                                <tfoot className="bg-blue-100 font-bold">
                                    <tr>
                                        <td></td> 
                                        <td className="text-left px-4 py-1 text-blue-800">
                                        Grand Total
                                        </td>
                                        <td className="text-center-style">{grandTotal.abovE_28K}</td>
                                        <td className="text-center-style">{grandTotal.k_25_28}</td>
                                        <td className="text-center-style">{grandTotal.k_20_25}</td>
                                         <td className="text-center-style">{grandTotal.k_15_20}</td>
                                        <td className="text-center-style">{grandTotal.beloW_15K}</td>
                                        <td className="text-center-style">{grandTotal.totaL_COUNT}</td>
                                    </tr>
                                </tfoot>

                        </table> */}
                    </div>
                }
            </>

            }
        </div>
    );
};

export default DivisionWiseSalesRange;